import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaNotesMedical, FaCapsules, FaFlask, FaMicroscope, FaDna, FaVials, FaHandHoldingMedical, FaChartLine } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/Drug.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {

        title: "Drug Discovery & Research",
        description: "The initial phase of drug development where scientists identify biological targets associated with diseases. Using high-throughput screening, computational modeling, and AI-driven drug design, researchers analyze thousands of compounds to determine potential candidates. Molecular optimization techniques are applied to enhance drug efficacy, reduce toxicity, and improve binding affinity before moving to preclinical testing."
    },
    {

        title: "Preclinical Testing",
        description: "A critical phase where drug candidates undergo extensive laboratory and animal studies to evaluate their safety, toxicity, pharmacokinetics (absorption, distribution, metabolism, and excretion), and pharmacodynamics (mechanism of action). This stage helps in determining appropriate dosages and identifying any potential adverse effects before human trials. Regulatory agencies require detailed preclinical data before approving clinical trials."
    },
    {

        title: "Clinical Trials",
        description: "Human testing is conducted in four phases to assess the safety, effectiveness, and optimal dosage of the drug. Phase I involves a small group of healthy volunteers to test safety and dosage. Phase II evaluates efficacy and side effects in a larger patient group. Phase III expands to thousands of patients in diverse populations to confirm effectiveness compared to standard treatments. Phase IV monitors long-term effects after market approval."
    },
    {

        title: "Pharmaceutical Formulation",
        description: "The process of developing a stable and effective drug formulation, optimizing its composition for safe delivery. Scientists determine the best dosage form (tablet, capsule, injection, etc.), ensure chemical stability, control drug release mechanisms (immediate-release, extended-release), and conduct bioavailability studies to maximize therapeutic impact while maintaining patient convenience and compliance."
    },
    {

        title: "Regulatory Approval & Compliance",
        description: "A highly regulated phase where pharmaceutical companies submit detailed clinical trial data, manufacturing processes, and safety evaluations to agencies like the FDA (U.S.), EMA (Europe), and WHO. Regulatory bodies review the findings to ensure the drug meets quality, efficacy, and safety standards. Compliance with Good Manufacturing Practices (GMP) and periodic audits are also required to maintain approval."
    },
    {

        title: "Pharmacovigilance & Drug Safety",
        description: "Post-marketing surveillance where pharmaceutical companies and regulatory agencies continuously monitor drug performance in real-world conditions. Adverse event reporting, risk-benefit assessments, and periodic safety updates help detect rare side effects and ensure ongoing patient safety. If necessary, regulatory actions such as label updates, usage restrictions, or product recalls may be implemented."
    },
    {

        title: "Market Access & Commercialization",
        description: "The final phase involves strategic planning to launch the drug into the market. Pricing models, reimbursement strategies, patient access programs, and global distribution networks are developed. Market research, medical education, and promotional campaigns are conducted to ensure adoption by healthcare providers and patients, maximizing the drug’s availability and commercial success."
    }
];
const features = [
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Advanced research methodologies for groundbreaking drug discovery." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Robust clinical trial strategies ensuring safety and efficacy." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Precision medicine approaches leveraging biotechnology innovations." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Optimized drug formulations for enhanced patient outcomes." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Regulatory expertise for seamless drug approvals worldwide." },
    { icon: <FaHandHoldingMedical className="text-[#2a627a] text-lg" />, text: "Comprehensive pharmacovigilance ensuring long-term drug safety." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Accelerates the availability of life-saving treatments." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhances patient safety through rigorous clinical testing." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Speeds up market entry of innovative therapies." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Enables precision medicine and targeted treatment approaches." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Ensures compliance with international drug approval standards." },
    { icon: <FaHandHoldingMedical className="text-[#2a627a] text-lg" />, text: "Reduces adverse effects through continuous post-market monitoring." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        role: "Clinical Research Scientist",
        text: "Designs and supervises clinical studies to evaluate the efficacy of new drug candidates."
    },
    {
        icon: <FaMicroscope className="text-[#2a627a] text-lg" />,
        role: "Pharmacologist",
        text: "Analyzes drug interactions within biological systems to optimize therapeutic effects."
    },
    {
        icon: <FaDna className="text-[#2a627a] text-lg" />,
        role: "Biotechnology Specialist",
        text: "Develops advanced biologics, gene therapies, and monoclonal antibody treatments."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        role: "Regulatory Affairs Specialist",
        text: "Manages regulatory submissions and ensures compliance with healthcare authorities."
    },
    {
        icon: <FaChartLine className="text-[#2a627a] text-lg" />,
        role: "Market Access Manager",
        text: "Develops strategies to facilitate drug pricing, reimbursement, and global distribution."
    },
    {
        icon: <FaVials className="text-[#2a627a] text-lg" />,
        role: "Pharmacovigilance Expert",
        text: "Monitors post-market drug safety and ensures regulatory reporting of adverse effects."
    }
];

const DrugDevelopment = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Drug Development - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        " Advancing safe, effective, and innovative therapeutics through rigorous research, clinical trials, and regulatory compliance to improve patient health."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Drug Development?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Drug development is the process of discovering, testing, and bringing new pharmaceutical treatments to market.
                            At HIKEHEALTH GS, we follow a rigorous, multi-phase approach to ensure the safety, efficacy, and compliance of
                            new medications. Our structured process includes preclinical research, clinical trials, regulatory approval,
                            and post-market monitoring, all aimed at advancing healthcare and improving patient outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in DrugDevelopment
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default DrugDevelopment;
